module.exports = __webpack_public_path__ + "unit-icon.png?96f04c1c1dc4b6a60ab01ca7ae393f08";